import { BaseEntityDTO, IBaseEntityDTO } from './base.entity.dto';

export interface IAssetDTO extends IBaseEntityDTO {
  filename: string;
  filepath: string;
  caption: string;
  ext: string;
  url: string;
  webp_url?: string;
  hls_url?: string;
  download_url: string;
  is_processing: boolean;
  processing_error?: string;
  createdAt?: Date;
  updatedAt?: Date;
  hasUrl(): boolean;
  hasWebPUrl(): boolean;
  hasHlsUrl(): boolean;
  fileType(): string;
}

export class AssetDTO extends BaseEntityDTO implements IAssetDTO {
  filename: string;

  filepath: string;

  caption: string;

  ext: string;

  url: string;
  webp_url?: string;
  hls_url?: string;
  download_url: string;
  is_processing: boolean;

  processing_error?: string;

  constructor(data?: Partial<AssetDTO>) {
    super();
    if (data) {
      Object.assign(this, data);
    }
    this.filename = data?.filename ?? '';
    this.filepath = data?.filepath ?? '';
    this.caption = data?.caption ?? '';
    this.ext = data?.ext ?? '';
    this.url = data?.url ?? '';
    this.hls_url = data?.hls_url ?? '';
    this.webp_url = data?.webp_url ?? '';
    this.is_processing = data?.is_processing ?? false;
    this.processing_error = data?.processing_error ?? undefined;
    this.download_url = data?.download_url ?? '';
  }
  hasUrl(): boolean {
    return !!this.url && this.url !== '';
  }

  hasHlsUrl(): boolean {
    return !!this.hls_url && this.hls_url !== '' && this.hls_url.match(/\.m3u8$/) !== null;
  }
  hasWebPUrl(): boolean {
    return !!this.webp_url && this.webp_url !== '' && this.webp_url.match(/\.webp$/) !== null;
  }

  fileType(): string {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
    const videoExtensions = ['mp4', 'mov', 'avi', 'wmv', 'flv', 'webm', 'mkv'];

    if (this.ext === 'pdf') {
      return 'pdf';
    } else if (imageExtensions.includes(this.ext)) {
      return 'image';
    } else if (videoExtensions.includes(this.ext)) {
      return 'video';
    }

    return 'unknown';
  }
}
